import * as React from 'react';

interface LocationHeaderProps {
  title: string;
}

export const LocationHeader: React.FunctionComponent<LocationHeaderProps> = ({ title }) => (
  <div className="uitk-cell all-cell-1-1 all-x-padding-three all-t-padding-three">
    <h2 className="uitk-type-heading-600 uitk-type-bold">{title}</h2>
  </div>
);

LocationHeader.displayName = 'PropertyLocationHeader';
